// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddProdColor_importCsvCard__1Xr02","addProdColorBtnContainer":"AddProdColor_addProdColorBtnContainer__LzQaN"};